import { FelaCSS } from '@bridebook/ui';

interface IStylesProps {
  noPadding: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
}

const styles = ({ noPadding }: IStylesProps): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: noPadding ? 0 : 4,
    marginTop: noPadding ? 0 : 0,
    fontDefaultSemiBold: 18,
    lineHeight: '22px',
  },
});

export default styles;
